<div class="container-fluid filter-box">
  <div class="col-12 d-flex mb-2 filter-content">
    <input
      type="text"
      class="form-control filter-input text-start"
      (keyup)="filterResults()"
      [(ngModel)]="searchTerm"
      placeholder="{{ 'companies.search' | translate }}"
    />
    <button class="btn btn-primary ms-2" (click)="newUser()">
      {{ 'user.btn_new_user' | translate }}
    </button>
  </div>
</div>
<div class="mat-elevation-z2">
  <table mat-table [dataSource]="dataSource" matSort class="fixed-table">
    <!-- First Name Column -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'user.name' | translate }}</th>
      <td [ngClass]="{'userActive': element.active == 0}" mat-cell *matCellDef="let element">
        {{element.firstName}}
      </td>
    </ng-container>

    <!-- Last Name Column -->
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'user.lastname' | translate }}</th>
      <td
        class="break"
        [ngClass]="{'userActive': element.active == 0}"
        mat-cell
        *matCellDef="let element"
      >
        {{element.lastName}}
      </td>
    </ng-container>

    <!-- EmailColumn -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'user.email' | translate }}</th>
      <td
        class="break"
        [ngClass]="{'userActive': element.active == 0}"
        mat-cell
        *matCellDef="let element"
      >
        {{element.email}}
      </td>
    </ng-container>

    <!-- My Account Column -->
    <ng-container matColumnDef="myAccount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td class="break" mat-cell *matCellDef="let element">
        <img
          *ngIf="element.email === currentAdmin.email"
          src="../../../assets/icons/icon_person_inactive.svg"
          class="icon"
          style="height: 30px"
        />
      </td>
    </ng-container>

    <!-- Is Active Column -->
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'user.active' | translate}}</th>
      <td
        class="break status"
        [ngClass]="{'active': element.active == 1, 'not-active': element.active == 0}"
        mat-cell
        *matCellDef="let element"
      >
        {{element.active == 1 ? '&#10003;' : '&#10005;'}}
      </td>
    </ng-container>

    <!-- Details Column -->
    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element" class="details">
        <div class="d-flex justify-content-end align-items-center">
          <div class="d-flex justify-content-start align-items-center">
            <div *ngIf="checkSyncStatus(element)" class="loader"></div>
          </div>
          <button
            [ngClass]="{
                            'btn-second': checkSyncStatus(element),
                            'btn-primary': !checkSyncStatus(element)
                        }"
            class="btn btn-xs-small"
            (click)="viewUser(element.id)"
          >
            details
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
</div>
